import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

const DELETE_ERROR_TITLE = 'Error on customer delete!'
const DELETE_ERROR_FALLBACK = 'An unexpected error occurred while deleting customer.'

/**
 * `DELETE /admin-api/customers/{customer}`. A refused delete (a finished lesson, a still-billing
 * subscription) answers 422 with a human-readable message, shown as is.
 */
export const useCustomerDestroy = async (customerId: number): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.customer.destroy', { customer_id: customerId })

  try {
    if (!url) {
      toast.error({ title: DELETE_ERROR_TITLE, description: DELETE_ERROR_FALLBACK })
      return false
    }

    const { data } = await $axios.delete<ApiResponse>(url)

    if (!data.success) {
      toast.error({ title: DELETE_ERROR_TITLE, description: data.message || DELETE_ERROR_FALLBACK })
      return false
    }

    toast.success({ title: 'Successfully deleted!', description: 'Selected Customer was successfully deleted!' })

    return true
  } catch (err: unknown) {
    toast.error({ title: DELETE_ERROR_TITLE, description: getAxiosErrorMessage(err) })
    return false
  }
}
